import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-plug-2-fill',
    title: 'New Construction Wiring',
    description:
      'Full electrical rough-in and finish work for new builds. We coordinate with builders and inspectors for seamless, code-compliant installations from foundation to final.',
    accent: '#00D9FF',
    href: '/services/new-construction',
  },
  {
    icon: 'ri-home-gear-fill',
    title: 'Residential Service & Repair',
    description:
      'Diagnose and repair electrical issues fast. From tripped breakers and faulty outlets to full panel replacements — reliable service with no unnecessary upsells.',
    accent: '#00D9FF',
    href: '/services/residential-repair',
  },
  {
    icon: 'ri-thunderstorms-fill',
    title: 'Generators',
    description:
      'Keep your home powered during outages. We install, maintain, and repair standby and portable generators with proper transfer switch setups and code compliance.',
    accent: '#D97706',
    href: '/services/generators',
  },
  {
    icon: 'ri-car-fill',
    title: 'Electric Car Chargers',
    description:
      'Level 1 and Level 2 EV charger installation for all major makes. We handle wiring, panel upgrades if needed, and permits — fast and professionally done.',
    accent: '#00D9FF',
    href: '/services/ev-chargers',
  },
  {
    icon: 'ri-sun-fill',
    title: 'Solar & Panel Upgrades',
    description:
      'Modern panel upgrades and solar-ready infrastructure. Upgrade your electrical system to handle today\'s energy demands with safe, lasting solutions.',
    accent: '#D97706',
    href: '/services/solar-panel',
  },
  {
    icon: 'ri-lightbulb-fill',
    title: 'Specialty Lighting',
    description:
      'Indoor and outdoor lighting design and installation. Recessed lighting, landscape systems, smart controls, and accent lighting that transforms your space.',
    accent: '#00D9FF',
    href: '/services/specialty-lighting',
  },
];

const ServicesOverview = () => (
  <section id="services" className="relative bg-sf py-28 overflow-hidden">
    {/* Grid pattern overlay */}
    <div className="absolute inset-0 opacity-[0.04] pointer-events-none">
      <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="grid" x="0" y="0" width="60" height="60" patternUnits="userSpaceOnUse">
            <path d="M 60 0 L 0 0 0 60" fill="none" stroke="#00D9FF" strokeWidth="1"/>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid)"/>
      </svg>
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
      {/* Header */}
      <div className="text-center mb-16 scroll-reveal">
        <span className="inline-block text-[#00D9FF] text-[11px] font-semibold uppercase tracking-[3px] mb-4">What We Do</span>
        <h2 className="text-4xl lg:text-5xl font-black text-[var(--tp)] mb-4">Electrical Services</h2>
        <p className="text-[var(--tm)] text-lg max-w-xl mx-auto">
          Comprehensive residential electrical solutions delivered with master-level skill and care.
        </p>
      </div>

      {/* Cards grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((service, i) => (
          <Link
            key={service.title}
            to={service.href}
            className={`scroll-reveal scroll-delay-${Math.min(i + 1, 6)} group relative bg-cr rounded-2xl p-8 border border-[var(--bd)] hover:border-[#00D9FF]/30 transition-all duration-400 hover:-translate-y-2 hover:shadow-[0_16px_48px_rgba(0,0,0,0.15)] cursor-pointer overflow-hidden block no-underline`}
          >
            {/* Glow effect on hover */}
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-400 pointer-events-none">
              <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#00D9FF]/40 to-transparent" />
            </div>

            {/* Icon */}
            <div
              className="w-14 h-14 flex items-center justify-center rounded-xl mb-6 transition-all duration-300 group-hover:scale-110"
              style={{ background: `linear-gradient(135deg, rgba(0,217,255,0.12) 0%, rgba(10,22,40,0.6) 100%)`, border: `1px solid ${service.accent}22` }}
            >
              <i className={`${service.icon} text-2xl`} style={{ color: service.accent }} />
            </div>

            {/* Content */}
            <h3 className="text-[18px] font-bold text-[var(--tp)] mb-3 leading-tight">{service.title}</h3>
            <p className="text-[var(--tm)] text-[14px] leading-relaxed">{service.description}</p>

            {/* Arrow */}
            <div className="mt-6 flex items-center gap-2 text-[#00D9FF] text-[13px] font-semibold opacity-0 group-hover:opacity-100 translate-x-0 group-hover:translate-x-1 transition-all duration-300">
              Learn more
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesOverview;
